"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[919],{

/***/ 70919:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ BlockParagraph; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/atoms/RichText/index.js + 1 modules
var RichText = __webpack_require__(36091);
// EXTERNAL MODULE: ./functions/wordpress/blocks/getBlockStyles.js
var getBlockStyles = __webpack_require__(6298);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./components/blocks/core/BlockParagraph/BlockParagraph.js





/**
 * Paragraph Block
 *
 * The core Paragraph block from Gutenberg.
 *
 * @author WebDevStudios
 * @param  {object}  props                    The component props.
 * @param  {string}  props.backgroundColorHex The background color hex value.
 * @param  {string}  props.className          Optional classnames.
 * @param  {string}  props.align              Optional alignment style.
 * @param  {string}  props.anchor             Optional anchor/id.
 * @param  {string}  props.content            The content of the block.
 * @param  {boolean} props.dropCap            Whether the paragraph has a drop cap.
 * @param  {object}  props.style              The style attributes (Typography panel).
 * @param  {string}  props.textColorHex       The text color hex value.
 * @return {Element}                          The RichText component.
 */ function BlockParagraph(param) {
    var align = param.align, anchor = param.anchor, backgroundColorHex = param.backgroundColorHex, className = param.className, content = param.content, dropCap = param.dropCap, style = param.style, textColorHex = param.textColorHex;
    var paragraphStyle = (0,getBlockStyles/* default */.Z)({
        backgroundColorHex: backgroundColorHex,
        textColorHex: textColorHex,
        style: style
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(RichText/* default */.Z, {
        className: classnames_default()(className, align === 'center' ? 'text-center' : null, !align || align === 'left' ? 'text-left' : null, align === 'right' ? 'text-right' : null),
        id: anchor,
        tag: "p",
        dropCap: dropCap,
        style: paragraphStyle,
        children: content
    }));
};
BlockParagraph.propTypes = {
    align: (prop_types_default()).string,
    anchor: (prop_types_default()).string,
    backgroundColorHex: (prop_types_default()).string,
    className: (prop_types_default()).string,
    content: (prop_types_default()).string,
    dropCap: (prop_types_default()).bool,
    style: (prop_types_default()).object,
    textColorHex: (prop_types_default()).string
};

;// CONCATENATED MODULE: ./components/blocks/core/BlockParagraph/index.js



/***/ }),

/***/ 6298:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getBlockStyles; }
/* harmony export */ });
/**
 * Get formatted block styles.
 *
 * @author WebDevStudios
 * @param  {object}          styles                    Various block custom and preset styles.
 * @param  {string}          styles.backgroundColorHex The background color hex value.
 * @param  {string}          styles.gradientHex        The background gradient hex value.
 * @param  {string}          styles.textColorHex       The text color hex value.
 * @param  {number | string} styles.width              The block width.
 * @param  {object}          styles.style              The style attributes.
 * @return {object}                                    The formatted style object.
 */ function getBlockStyles(param) {
    var backgroundColorHex = param.backgroundColorHex, gradientHex = param.gradientHex, textColorHex = param.textColorHex, width = param.width, style = param.style;
    var ref, ref1, ref2, ref3, ref4;
    var blockStyle = {};
    // Determine styles, using stylelint-accepted const names.
    var background = gradientHex || (style === null || style === void 0 ? void 0 : (ref = style.color) === null || ref === void 0 ? void 0 : ref.gradient);
    var backgroundcolor = backgroundColorHex || (style === null || style === void 0 ? void 0 : (ref1 = style.color) === null || ref1 === void 0 ? void 0 : ref1.background);
    var fontsize = style === null || style === void 0 ? void 0 : (ref2 = style.typography) === null || ref2 === void 0 ? void 0 : ref2.fontSize;
    var fontweight = style === null || style === void 0 ? void 0 : (ref3 = style.typography) === null || ref3 === void 0 ? void 0 : ref3.fontWeight;
    var textcolor = textColorHex || (style === null || style === void 0 ? void 0 : (ref4 = style.color) === null || ref4 === void 0 ? void 0 : ref4.text);
    // Only add styles if set.
    if (background) {
        blockStyle.background = background;
    }
    if (backgroundcolor) {
        blockStyle.backgroundColor = backgroundcolor;
    }
    if (fontsize) {
        blockStyle.fontSize = fontsize;
    }
    if (fontweight) {
        blockStyle.fontWeight = fontweight;
    }
    if (textcolor) {
        blockStyle.color = textcolor;
    }
    if (width) {
        if (isNaN(width)) {
            // If width is not a number, return full string.
            blockStyle.width = width;
        } else {
            // If width is a number, return as percent.
            blockStyle.width = "".concat(width, "%");
        }
    }
    return blockStyle;
};


/***/ })

}]);